import { render } from "./LoadingSpinner.vue?vue&type=template&id=6977a179&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=6977a179&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6977a179"]])

export default __exports__